<template>
  <v-form v-model="isFormValid">
    <v-card :loading="isLoadingBt">
      <b-row align-v="center" style="margin-bottom: 2rem; margin-top: 1rem">
        <b-col cols="1">
          <a class="custom-back justify-start" @click="onGoBack">
            <b-img :src="require('../../../assets/images/ic-arrow-left.svg')
              " />
          </a>
        </b-col>
        <b-col>
          <b-card-text class="form-title">
            {{ $t("ui.newPassword") }}
          </b-card-text>
        </b-col>
      </b-row>
      <b-card-text class="mb-2">{{ $t("ui.changePassDec") }}</b-card-text>

      <div class="mb-2">{{ $t("ui.newPassword") }}</div>
      <v-text-field color="#40A9FF" dense outlined :type="passwordType" v-model="newPassword" :rules="rulePassWord"
        placeholder="••••••••" name="password" :hint="$t('ui.MSG0051')" persistent-hint>
        <template v-slot:append>
          <v-fade-transition leave-absolute>
            <a>
              <img style="margin-top: 4px" @click="onShowPass" width="16" height="16" :src="passwordType === 'password'
                  ? require('../../../assets/images/ic-pw-hide.svg')
                  : require('../../../assets/images/ic-pw-show.svg')
                ">
            </a>
          </v-fade-transition>
        </template>

      </v-text-field>

      <div class="mb-2">{{ $t("ui.newPasswordAgain") }}</div>
      <v-text-field color="#40A9FF" dense outlined :type="passwordAgainType" v-model="newPasswordAgain"
        :error="validPasswordMsg !== ''" placeholder="••••••••" name="passwordAgain">
        <template v-slot:append>
          <v-fade-transition leave-absolute>
            <a>
              <img style="margin-top: 4px" @click="onShowPassAgain" width="16" height="16" :src="passwordAgainType === 'password'
                  ? require('../../../assets/images/ic-pw-hide.svg')
                  : require('../../../assets/images/ic-pw-show.svg')
                ">
            </a>
          </v-fade-transition>
        </template>

      </v-text-field>
      <div v-if="validPasswordMsg" style="margin-top: -20px" class="mark-title text-body-2 ms-3">
        {{ validPasswordMsg }}
      </div>
      <b-row class="custom-button" style="margin-top: 14.5rem">
        <b-col>
          <b-button v-if="!isLoadingBt" variant="primary" class="custom-submit"
            :disabled="!isFormValid || !validChangePassword || validPasswordMsg !== ''" @click="handleChangePass">
            {{ $t("ui.confirmNewPassword") }}
          </b-button>
          <b-button v-else variant="primary" class="custom-submit">
            <b-spinner small type="grow" />
            {{ $t("ui.confirmNewPassword") }}
          </b-button>
        </b-col>
      </b-row>
    </v-card>
  </v-form>

</template>

<script>
import i18n from "../../../lang/i18n";
import { mapState } from "vuex";
import { API2 } from "../../../api";
import routes from "../../../routes";
import path from "../../../routes/path";
import mixin from "../../../mixin";

export default {
  mixins: [mixin],
  props: {
    gotoLoginTab: {
      type: Function,
      required: true
    },
    otp: {
      type: String
    }
  },
  data() {
    return {
      passwordType: 'password',
      passwordAgainType: 'password',
      newPassword: '',
      newPasswordAgain: '',
      isLoadingBt: false,
      isFormValid: false,
    };
  },
  computed: {
    rulePassWord() {
      return [
        this.newPassword && this.newPassword.length >= 8
        && /[A-Z]/.test(this.newPassword)
        && /[!@#$%^&*(),.?":{}|<>]/.test(this.newPassword)
        && /[0-9]/.test(this.newPassword)
        && !/\s/.test(this.newPassword)
        || this.$t("ui.MSG0051"),
      ]
    },
    validPasswordMsg() {
      return this.newPassword === this.newPasswordAgain
        || this.newPasswordAgain === '' ? '' : this.$t('ui.passwordNotMatch')
    },
    validChangePassword: function () {
      return this.newPassword && this.newPasswordAgain
    },
    ...mapState([
      'accountReceiveOtp',
    ]),
  },
  methods: {
    async handleChangePass() {
      let res = await this.put(API2.LOGIN_CHANGE_PASSWORD, {
        email: this.accountReceiveOtp,
        password: this.newPassword,
        confirmPassword: this.newPasswordAgain,
        otp: this.otp,
        fgp: 1
      }, "isLoadingBt", false
      )
      if (res.data.status !== 200) {
        let error = res.data.error
        this.showToast('danger', i18n.t("ui.anErrorOccurred"), error.message)

        return
      }

      this.showOverlay('success', i18n.t("ui.passwordChangeSuccess"), i18n.t("ui.changePasswordSuccessfulSubtitle"), i18n.t("login.login"),
        () => {
          window.location.href = path.login
        })
    },
    onShowPass() {
      this.passwordType = this.passwordType === "password" ? "text" : "password";
    },
    onShowPassAgain() {
      this.passwordAgainType = this.passwordAgainType === "password" ? "text" : "password";
    },
    onGoBack() {
      this.newPassword = null
      this.newPasswordAgain = null
      this.gotoLoginTab(2)
    },
  },

}
</script>

<style scoped>
.custom-submit:hover {
  background-color: #40A9FF;
  border-color: #40A9FF;
  color: #ffffff;
}

.custom-submit:disabled {
  background-color: #F5F5F5;
  border-color: #D9D9D9;
  color: #00000040;

}

.custom-submit {
  border-radius: 3px;
  background-color: #1890FF;
  width: 100%;
  color: #ffffff;
}

.form-title {
  font-size: 16px;
  color: #000000;
  font-weight: bold;
}
</style>